module.exports = __webpack_public_path__ + "static/pawel-md-b49c7a839122ed51c9d29b792479122b.jpg";